import { useFetchData } from "../../../hooks/useFetch";
import {
  ApiConfig,
  API_SERVICE_VARIANTS_ROUTER,
} from "../../../services/api-config";

export interface ServiceVariant {
  id: number;
  name: string;
  service_id?: number;
  status?: number;
}

export interface ServiceVariantListResponse {
  list: ServiceVariant[];
  total_record: number;
  limit?: number;
}

export interface ServiceVariantListFilters {
  service_id?: number;
  status?: number;
}

export const ServiceVariantsService = {
  list: () => {
    const { request, baseResponse, loading } =
      useFetchData.Get<ServiceVariantListResponse>({
        projectId: ApiConfig.PROJECT_ID.PRODUCT_SERVICE,
      });

    return {
      fetch: (params: ServiceVariantListFilters = { status: -1 }) =>
        request({
          endPoint: API_SERVICE_VARIANTS_ROUTER.API_LIST,
          data: params,
        }),
      response: baseResponse,
      loading : loading,
    };
  },
  listActive: () => {
    const { request, baseResponse, loading } =
      useFetchData.Get<ServiceVariantListResponse>({
        projectId: ApiConfig.PROJECT_ID.PRODUCT_SERVICE,
      });

      return {
        fetch: (params: ServiceVariantListFilters = {}) =>
          request({
            endPoint: API_SERVICE_VARIANTS_ROUTER.API_LIST,
            data: { status: 1, ...params },
      }),
      response: baseResponse,
      loading : loading,
    };
  },
  detail: () => {
    const { request, baseResponse, loading } = useFetchData.Get<ServiceVariant>({
      projectId: ApiConfig.PROJECT_ID.PRODUCT_SERVICE,
    });
    return {
      fetch: (id: number) =>
        request({
          endPoint: API_SERVICE_VARIANTS_ROUTER.API_DETAIL(id),
        }),
      response: baseResponse,
      loading : loading,
    };
  },
};

export default ServiceVariantsService;
